module.exports = __webpack_public_path__ + "static/media/app.36422cc8.png";